var _defs, _path, _path2, _script;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThickAnimated = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eN7On2dzTlx1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "eN7On2dzTlx4-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "eN7On2dzTlx4-filter-drop-shadow-0-blur",
    in: "SourceAlpha",
    stdDeviation: "1,0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    id: "eN7On2dzTlx4-filter-drop-shadow-0-offset",
    dx: 0,
    dy: 1,
    result: "tmp"
  }), /*#__PURE__*/React.createElement("feFlood", {
    id: "eN7On2dzTlx4-filter-drop-shadow-0-flood",
    floodColor: "rgba(0,0,0,0.3)"
  }), /*#__PURE__*/React.createElement("feComposite", {
    id: "eN7On2dzTlx4-filter-drop-shadow-0-composite",
    operator: "in",
    in2: "tmp"
  }), /*#__PURE__*/React.createElement("feMerge", {
    id: "eN7On2dzTlx4-filter-drop-shadow-0-merge"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    id: "eN7On2dzTlx4-filter-drop-shadow-0-merge-node-1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    id: "eN7On2dzTlx4-filter-drop-shadow-0-merge-node-2",
    in: "SourceGraphic"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "eN7On2dzTlx5",
    d: "M31.999999,16.559383l5.528134-9.849075",
    transform: "translate(-24.116554-3.634846)",
    opacity: 0,
    fill: "none",
    stroke: "#192128",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDashoffset: 11.234933,
    strokeDasharray: 11.29
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "eN7On2dzTlx6",
    d: "M31.999999,16.559383L26.813206,11.58073",
    transform: "matrix(-1 0 0-1 34.588419 24.505268)",
    opacity: 0,
    fill: "none",
    stroke: "#192128",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDashoffset: 11.234933,
    strokeDasharray: 11.234933
  })), _script || (_script = /*#__PURE__*/React.createElement("script", null)));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThickAnimated);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/thick-animated.e50bfb5c3a2a9421ffaf494809a74a14.svg";